import { Helmet } from "react-helmet";


const HeadFont = ({ fonts }) => {
    return <Helmet>
        {fonts && fonts.length && fonts.map((font, index) => (
            <link href={`https://fonts.googleapis.com/css?family=${font.family}:${JSON.parse(font.variants).join(',')}`} key={index} rel="stylesheet" />
        ))}
    </Helmet>
}

export default HeadFont